(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["market-drawer-item"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('market-drawer-form')) {
    class MarketDrawerForm extends HTMLElement {
      connectedCallback() {
        this.form = this.querySelector('form');
        this.input = this.querySelector('input[name="country_code"]');
        if (!this.form || !this.input) return;

        this.querySelectorAll('a[data-value]').forEach((link) =>
          link.addEventListener('click', (event) => {
            event.preventDefault();
            this.input.value = link.dataset.value;
            this.form.submit();
          })
        );
      }
    }

    customElements.define('market-drawer-form', MarketDrawerForm);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["market-localization"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('market-selector')) {
    class MarketSelector extends HTMLElement {
      connectedCallback() {
        this.button = this.querySelector('.localization-form__select');
        this.panel = this.querySelector('.disclosure__list-wrapper');
        this.list = this.querySelector('.disclosure__list');
        this.header = this.closest('.header-wrapper');
        if (!this.button || !this.panel || !this.list || !this.header) return;

        this.positionList = this.positionList.bind(this);
        this.observer = new MutationObserver(() => this.onToggle());
        this.observer.observe(this.panel, { attributes: true, attributeFilter: ['hidden'] });
        window.addEventListener('resize', this.positionList);
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        window.removeEventListener('resize', this.positionList);
        this.header?.classList.remove('market-selector-open');
      }

      onToggle() {
        const isOpen = !this.panel.hasAttribute('hidden');
        this.header.classList.toggle('market-selector-open', isOpen);
        if (isOpen) this.positionList();
      }

      positionList() {
        if (this.panel.hasAttribute('hidden')) return;
        const headerRect = this.header.getBoundingClientRect();
        const buttonRect = this.button.getBoundingClientRect();
        const maxOffset = Math.max(headerRect.width - this.list.offsetWidth, 0);
        const offset = Math.min(Math.max(buttonRect.left - headerRect.left, 0), maxOffset);
        this.panel.style.setProperty('--market-list-offset', `${offset}px`);
      }
    }

    customElements.define('market-selector', MarketSelector);
  }
  } catch(e) { console.error(e); }
})();

})();
